import ListLoadingSkeleton from 'components/molecules/ListLoadingSkeleton/ListLoadingSkeleton.component';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const chatSkeletonColumns = [
  {
    className: 'h-8 w-8 self-start',
    content: <Skeleton className="h-8 w-8" circle />,
  },
  {
    className: 'flex-1',
    content: (
      <div className="ml-4">
        <Skeleton className="h-3 !w-7/12" />
        <Skeleton className="h-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-3 !w-7/12 mt-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-3 !w-7/12 mt-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-2" />
        <Skeleton className="h-2" />
      </div>
    ),
  },
  {
    className: 'w-3/12 px-10',
    content: null,
  },
];

const ChatSkeleton: FC = () => (
  <ListLoadingSkeleton columns={chatSkeletonColumns} count={1} />
);

export default ChatSkeleton;
